<!-- Desktop Version -->
<div class="d-none d-lg-block" style="width: 100vw">
  <div class="row">
    <div class="col-12 col-md-2 col-lg-2 col-sm-2">
      <a href="https://lendingman.com"> <img src="assets/logos/lendingman_desktop_app.svg" width="150" height="95" alt="LendingMan Logo" class="img-responsive" style="padding-top: 5px;"></a>
    </div>


  </div>
</div>
<!-- Mobile Version -->
<div class="row d-lg-none">
  <div class="navbar-brand minimum">
    <a href="https://lendingman.com"><img src="assets/logos/lendingman_mobile_app.svg" width="60" height="60" alt="LendingMan Mobile Logo"></a>
  </div>
</div>

